module.exports = __webpack_public_path__ + "static/35-61766f9677fccc0d6711ecd53f3e11cc.png";